import React from 'react';
import './search.css'

const Search = (props) => {
    return ( <>
    <div className='search'>
        <div className='searchicon'></div>
        <h6 className='searchtext'>{props.search}</h6>
    </div>
    </> );
}
 
export default Search;